<template>
    <div class="notice-container">
        <div class="breadcrumb">
            콘텐츠 관리 &gt; 공지사항 관리
        </div>
        <div class="filter-row">
            <select v-model="status" class="select-status">
                <option>전체</option>
                <!-- 필요하다면 다른 옵션도 추가하세요 -->
            </select>
            <input v-model="searchTerm" class="search-box" placeholder="검색어 입력" />
            <button class="btn search">검색</button>
        </div>
        <div class="button-row">
            <button class="btn delete">삭제</button>
            <button class="btn edit">수정</button>
            <button class="btn register">등록</button>
        </div>
        <table class="notice-table">
            <thead>
            <tr>
                <th><input type="checkbox" /></th>
                <th>제목</th>
                <th>작성일</th>
                <th>작성자</th>
                <th>노출 대상</th>
                <th>상태</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, idx) in noticeData" :key="idx">
                <td><input type="checkbox" /></td>
                <td>{{ row.title }}</td>
                <td>{{ row.date }}</td>
                <td>{{ row.author }}</td>
                <td>{{ row.target }}</td>
                <td>{{ row.status }}</td>
            </tr>
            </tbody>
        </table>
        <div class="pagination">&lt; 1 &gt;</div>
    </div>
</template>

<script>
import axios from 'axios';  // axios로 API 호출 가정

export default {
    name: 'Announcement',
    data() {
        return {
            status: '',                 // 선택된 상태 값, 빈 문자열은 전체 의미
            searchTerm: '',             // 검색어
            noticeData: [],             // 공지사항 리스트 배열
            selectedNotices: [],        // 체크된 공지 id 리스트
            allSelected: false          // 전체선택 체크박스 상태
        };
    },
    methods: {
        // 공지사항 목록 불러오기 (검색조건 포함)
        async fetchNotices() {
            try {
                const res = await axios.get(`/api/content/AnnouncementList`, {
                    // 실제 넘겨야 할 검색 조건 혹은 빈 객체
                });
                // 응답 데이터 구조에 따라 아래 할당
                this.noticeData = res.data.list || res.data || [];
                this.totalCount = this.noticeData.length;  // 예시로 totalCount 계산
            } catch (err) {
                console.error('공지사항 불러오기 실패', err);
            }
        },

    },
    mounted() {
        this.fetchNotices(); // 컴포넌트 로드 시 공지사항 초기 조회
    }
};
</script>
